import React, { useRef, useState, useEffect } from "react";

const ChatAudio = ({ url, id, activeAudioId, onAudioPlay }) => {
  const audioRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [current, setCurrent] = useState(0);
  const [duration, setDuration] = useState(0);

  const togglePlay = () => {
    if (!isPlaying) {
      onAudioPlay(id); // tell parent I'm playing
      audioRef.current.play();
      setIsPlaying(true);
    } else {
      audioRef.current.pause();
      setIsPlaying(false);
    }
  };

  // Pause if another audio becomes active
  useEffect(() => {
    if (activeAudioId !== id && isPlaying) {
      audioRef.current.pause();
      setIsPlaying(false);
    }
  }, [activeAudioId, id, isPlaying]);

  useEffect(() => {
    const audio = audioRef.current;

    const updateTime = () => setCurrent(audio.currentTime);
    const setMeta = () => setDuration(audio.duration);

    const onEnded = () => {
      setIsPlaying(false);
      setCurrent(0);
      audio.currentTime = 0;
    };

    audio.addEventListener("timeupdate", updateTime);
    audio.addEventListener("loadedmetadata", setMeta);
    audio.addEventListener("ended", onEnded);

    return () => {
      audio.removeEventListener("timeupdate", updateTime);
      audio.removeEventListener("loadedmetadata", setMeta);
      audio.removeEventListener("ended", onEnded);
    };
  }, []);

  const formatTime = (seconds) => {
    if (!seconds) return "0:00";
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60).toString().padStart(2, "0");
    return `${mins}:${secs}`;
  };

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "10px",
        background: "#f1f1f1",
        padding: "10px 14px",
        borderRadius: "12px",
        width: "260px",
      }}
    >
      <button
        onClick={togglePlay}
        style={{
          border: "none",
          background: "none",
          cursor: "pointer",
          fontSize: "20px",
        }}
      >
        {isPlaying ? "⏸" : "▶️"}
      </button>

      <input
        type="range"
        min={0}
        max={duration || 0}
        value={current}
        onChange={(e) => {
          const val = Number(e.target.value);
          audioRef.current.currentTime = val;
          setCurrent(val);
        }}
        style={{ flex: 1 }}
      />

      <div style={{ fontSize: "12px" }}>
        {formatTime(current)} / {formatTime(duration)}
      </div>

      <audio ref={audioRef} src={url} preload="metadata" />
    </div>
  );
};

export default ChatAudio;
